var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpgradeChipPro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1C4.5 1.92826 4.86875 2.8185 5.52513 3.47487C6.1815 4.13125 7.07174 4.5 8 4.5C7.07174 4.5 6.1815 4.86875 5.52513 5.52513C4.86875 6.1815 4.5 7.07174 4.5 8C4.5 7.07174 4.13125 6.1815 3.47487 5.52513C2.8185 4.86875 1.92826 4.5 1 4.5C1.92826 4.5 2.8185 4.13125 3.47487 3.47487C4.13125 2.8185 4.5 1.92826 4.5 1Z",
    fill: "#FA4616",
    stroke: "#FA4616",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6C9 6.66304 9.26339 7.29893 9.73223 7.76777C10.2011 8.23661 10.837 8.5 11.5 8.5C10.837 8.5 10.2011 8.76339 9.73223 9.23223C9.26339 9.70107 9 10.337 9 11C9 10.337 8.73661 9.70107 8.26777 9.23223C7.79893 8.76339 7.16304 8.5 6.5 8.5C7.16304 8.5 7.79893 8.23661 8.26777 7.76777C8.73661 7.29893 9 6.66304 9 6Z",
    fill: "#FA4616",
    stroke: "#FA4616",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeChipPro);
export default __webpack_public_path__ + "static/media/upgradeChipPro.6445b3837a4468834d9971469cbc12d1.svg";
export { ForwardRef as ReactComponent };